import React from 'react'

export default function Telegram() {
    return (
        <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.665 3.71706L2.935 10.5541C1.725 11.0401 1.732 11.7151 2.713 12.0161L7.265 13.4361L17.797 6.79106C18.295 6.48806 18.75 6.65106 18.376 6.98306L9.843 14.6841H9.841L9.843 14.6851L9.529 19.3771C9.989 19.3771 10.192 19.1661 10.45 18.9171L12.661 16.7671L17.26 20.1641C18.108 20.6311 18.717 20.3911 18.928 19.3791L21.947 5.15106C22.256 3.91206 21.474 3.35106 20.665 3.71706Z" fill="white" />
            </svg>

        </div>
    )
}
